let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let Modal = require("ES/widgets/Modal");
let radio = require("ES/lib/react-pubsub-via-radio.js/radio");
let esUtils = require("ES/utils/esUtils");
let RadioMixin = require("ES/lib/react-pubsub-via-radio.js/RadioMixin");
let ErrorAlert = require("ES/widgets/ErrorAlert");
let LoadingWrap = require("ES/widgets/LoadingWrap");
let RadioServiceMixin = require("ES/lib/react-pubsub-via-radio.js/RadioServiceMixin");

let yesNoBtns = function(onYes, onNo){
	return [
		{
			name: "Yes",
			onClick: onYes,
			className: "btn btn-primary"
		},
		{
			name: "No",
			onClick: onNo,
			className: "btn btn-default"
		}
	];
};

let AddRoyaltiesModal = dd.createClass({
	mixins: [RadioServiceMixin],
	getInitialState(){
		return {all_done: false};
	},
	RadioService_setup(){
		return {
			EventServices_computeAndAddRoyalties: {
				key: "callService",
				on: {
					succeeded(){
						radio("reload_Event").broadcast(this.props.eid);
						this.setState({all_done: true});
					}
				}
			}
		};
	},
	__yesAddNewRoyalties: esUtils.wrapPreventDefault(function(){
		let {eid, clear_old_royalties} = this.props;
		this.RadioService_callService("EventServices_computeAndAddRoyalties", {eid, clear_old_royalties});
	}),
	render(){
		let {onClose} = this.props;
		let ajax = this.state.EventServices_computeAndAddRoyalties;
		if(ajax.waiting){
			return Modal({
					title: "Adding royalties...",
					buttons: []
				},
				LoadingWrap({is_loading: true, text: "Adding royalties..."})
			);
		}
		if(ajax.error){
			return Modal({
					title: "Unable to add royalties",
					onClose
				},
				ErrorAlert({message: ajax.error})
			);
		}
		if(this.state.all_done){
			return Modal({
					title: "Added Royalties",
					onClose
				},
				ajax.data || "Added Royalties"
			);
		}
		return Modal({
				title: "Add Royalties",
				buttons: yesNoBtns(this.__yesAddNewRoyalties, onClose),
				onClose
			},
			"Do you want to add new royalty items based on the EVENT TYPE, DELIVERY METHOD, PRESENTATION CATEGORY and PRODUCT?"
		);
	}
});

module.exports = dd.createClass({
	mixins: [RadioMixin],
	getInitialState(){
		return {
			event: null,
			asked_do_you_want_to_clear_old_royalties: false,
			clear_old_royalties: false
		};
	},
	Radio_setup(){
		return {
			royalty_dependant_item_changed(event){
				this.setState({event});
			},
			add_royalty_items(event){
				this.setState({event});
			}
		};
	},
	__yesRemove: esUtils.wrapPreventDefault(function(){
		this.setState({asked_do_you_want_to_clear_old_royalties: true, clear_old_royalties: true});
	}),
	__noRemove: esUtils.wrapPreventDefault(function(){
		this.setState({asked_do_you_want_to_clear_old_royalties: true, clear_old_royalties: false});
	}),
	__close: esUtils.wrapPreventDefault(function(){
		this.setState({event: null, asked_do_you_want_to_clear_old_royalties: false});
	}),
	render(){
		let {event, asked_do_you_want_to_clear_old_royalties, clear_old_royalties} = this.state;
		if(!event){
			return dd.span();
		}
		let has_royalties = _.any(event && event.Service, function(s){
			return !!(s && s.flags_as_map && s.flags_as_map.is_royalty && s.flags_as_map.is_royalty.is_set);
		});
		if(has_royalties && !asked_do_you_want_to_clear_old_royalties){
			return Modal({
					title: "Remove Royalties",
					buttons: yesNoBtns(this.__yesRemove, this.__noRemove)
				},
				"Do you want to remove the current royalty items?"
			);
		}
		return AddRoyaltiesModal({eid: event.eid, clear_old_royalties, onClose: this.__close});
	}
});



// WEBPACK FOOTER //
// ./src/components/modals/RoyaltyChange.js